/**
 * Хеш-функция FNV-1a (64-бит)
 * Возвращает 16-символьную шестнадцатеричную строку
 * Используется для генерации уникальных ключей API-запросов
 */
export function fnv1aHash(str: string): string {
  let h1 = 0x811c9dc5;
  let h2 = 0x811c9dc5;

  for (let i = 0; i < str.length; i++) {
    h1 ^= str.charCodeAt(i);
    h1 = Math.imul(h1, 0x01000193);
    h2 ^= str.charCodeAt(i);
    h2 = Math.imul(h2, 0x01000193);
  }

  return h1.toString(16) + h2.toString(16);
}
